import React from 'react';
import type { Options as MarkdownOptions } from 'react-markdown';
import { BasicMarkdown } from '@trinity/chat-components/components/Markdown/Markdown';
import { StyledProfileWidgetP, StyledList, StyledListItem } from './shared-styles';

const profileMarkdownComponents: MarkdownOptions['components'] = {
  p: (props) => <StyledProfileWidgetP>{props.children}</StyledProfileWidgetP>,
  ul: (props) => <StyledList>{props.children}</StyledList>,
  li: (props) => <StyledListItem>{props.children}</StyledListItem>,
};

export const ProfileMarkdown: React.FC<{
  content: string;
}> = ({ content }) => {
  return <BasicMarkdown components={profileMarkdownComponents}>{content}</BasicMarkdown>;
};
